// action types
import { AsyncActionType } from './helpers';

// Storage Actions
export const CLEAR_BROWSER_STORAGE_ITEM = 'CLEAR_BROWSER_STORAGE_ITEM';
export const SET_BROWSER_STORAGE_ITEM = 'SET_BROWSER_STORAGE_ITEM';
export const GET_BROWSER_STORAGE_ITEMS = 'GET_BROWSER_STORAGE_ITEMS';

// growl/toast
export const CREATE_ALERT = 'CREATE_ALERT';
export const DELETE_ALERT = 'DELETE_ALERT';

// connected router actions
export const LOCATION_CHANGE = '@@router/LOCATION_CHANGE';

// PAGINATION
export const CONFIGURE_PAGINATION = 'SET_PAGINATION';

// user info
export const LOAD_CURRENT_USER_INFO = new AsyncActionType('LOAD_CURRENT_USER_INFO');
export const CLEAR_USER_SESSION = 'CLEAR_USER_SESSION';

// customer permissions
export const LOAD_CUSTOMER_PERMISSIONS = new AsyncActionType('LOAD_CUSTOMER_PERMISSIONS');

export const SORT_BY = 'SORT_BY';

// job form
export const GET_MAGIC_ALGORITHM_RESULTS = new AsyncActionType(
  'GET_MAGIC_ALGORITHM_RESULTS_REQUEST'
);
export const GET_REQUIREMENTS_TAGS = new AsyncActionType('GET_REQUIREMENTS_TAGS');
export const GET_FILL_ADVISOR_DATA = new AsyncActionType('GET_FILL_ADVISOR_DATA');

export const JOB_FORM_UPDATE_ACTIVE_SECTION = 'JOB_FORM_UPDATE_ACTIVE_SECTION';
export const JOB_FORM_UPDATE_VALID_SECTIONS = 'JOB_FORM_UPDATE_VALID_SECTIONS';
export const JOB_FORM_CLEAR_SECTION_DATA = 'JOB_FORM_CLEAR_SECTION_DATA';
export const JOB_FORM_SET_VALID_SECTIONS = 'JOB_FORM_SET_VALID_SECTIONS';

// tryouts
export const UPDATE_TRYOUT_BADGES = 'UPDATE_TRYOUT_BADGES';
export const DELETE_TRYOUT_BADGES = 'DELETE_TRYOUT_BADGES';

// postMessage
export const SEND_DATA = 'SEND_DATA';
export const RECEIVE_DATA = 'RECEIVE_DATA';
export const SEND_DATA_NOOP = 'SEND_DATA_NOOP';
export const POST_MESSAGE_RESPONSE = 'POST_MESSAGE_RESPONSE';
export const CLEAR_POST_MESSAGE = 'CLEAR_POST_MESSAGE';

export const UPDATE_FEATURE_USER_SETTINGS = 'UPDATE_FEATURE_USER_SETTINGS';
export const CLEAR_FEATURE_USER_SETTINGS = 'CLEAR_FEATURE_USER_SETTINGS';
export const LOAD_FEATURE_USER_SETTINGS = new AsyncActionType('LOAD_FEATURE_USER_SETTINGS');
export const TRACK_SEGMENT_EVENT = 'TRACK_SEGMENT_EVENT';

// message page actions
export const SELECT_JOB_ID_OF_MESSAGE_THREAD = 'SELECT_JOB_ID_OF_MESSAGE_THREAD';
export const SELECT_ALL_MESSAGE_THREADS = 'SELECT_ALL_MESSAGE_THREADS';
export const CLEAR_MESSAGE_THREAD_SELECTIONS = 'CLEAR_MESSAGE_THREAD_SELECTIONS';
export const SET_MESSAGE_MODAL_JOB_ID = 'SET_MESSAGE_MODAL_JOB_ID';

// wanda page actions
export const SET_WANDA_VENUE_MODAL_DATA = 'SET_WANDA_VENUE_MODAL_DATA';

// preferred modal actions
export const PREFERRED_MODAL_UPDATE_PREFERRED_WONOLOERS = 'PREFERRED_MODAL_UPDATE_PREFERRED_WONOLOERS';
export const PREFERRED_MODAL_UPDATE_PREFERRED_TEAMS = 'PREFERRED_MODAL_UPDATE_PREFERRED_TEAMS';
export const PREFERRED_MODAL_SELECT_WONOLOER = 'PREFERRED_MODAL_SELECT_WONOLOER';
export const PREFERRED_MODAL_SELECT_TEAM = 'PREFERRED_MODAL_SELECT_TEAM';
export const PREFERRED_MODAL_HYDRATE = 'PREFERRED_MODAL_HYDRATE';
export const PREFERRED_MODAL_UPDATE_IS_CLOSED_PREFERRED = 'PREFERRED_MODAL_UPDATE_IS_CLOSED_PREFERRED';
